// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"e0b29400","405":"fc7c6438","784":"77ab3a6f","787":"450b753b"}[chunkId] + ".chunk.js";
};